import React, { useState } from 'react';
import { Button } from '@mui/material';
import styled from '@emotion/styled';

const StyledButton = styled(Button)`
    text-transform: none; /* Prevents text transformation to uppercase */
    padding: 0;
`;

const TextLinkButton = ({ action, text }) => {
    return (
        <StyledButton onClick={action}>{text}</StyledButton>
    );
};

export default TextLinkButton;
